import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
const menuCategories = [{
  title: 'Catering Menu',
  description: 'Farmer\u2019s market sourced, African and Mediterranean inspired dishes for your event.',
  items: [{
    name: 'Salad',
    desc: 'Arugula, beets, tomatoes, shallots, garlic, lemon, cider vinegar, salt, pepper, cheese.',
    dietary: ['Vegetarian', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Prawns',
    desc: 'Prawns, couscous, vegetables, onions, garlic, saffron, tomatoes, peppers, spices.',
    dietary: ['No Dairy', 'No Nuts', 'No Soy']
  }, {
    name: 'Chicken Jambalaya',
    desc: 'Chicken tenders, turkey bacon, rice, vegetables, tomatoes, spices, peppers, garlic, rice.',
    dietary: ['No Dairy', 'No Gluten', 'No Nuts', 'No Shell Fish', 'No Soy']
  }, {
    name: 'Meatballs',
    desc: '90% fat free ground beef, shallots, garlic, herbs, spices, quinoa, vegetables.',
    dietary: ['No Dairy', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Lentils',
    desc: 'Lentils, rice, saffron, vegetables, spices, peppers, tomatoes.',
    dietary: ['Vegan', 'No Dairy', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Eggplant',
    desc: 'Eggplant, mushrooms, black eye peas, cheese, pearled barley, vegetables.',
    dietary: ['Vegetarian', 'No Nuts', 'No Soy']
  }, {
    name: 'Seven Vegetable Tagine',
    desc: 'Seven vegetable tagine with garbanzo beans, preserved lemon and green chermoula.',
    dietary: ['Vegan', 'No Dairy', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Wild Salmon',
    desc: 'Wild salmon with wild rice, artichokes, swiss chard and zhoug.',
    dietary: ['No Dairy', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Smoked Trout Baccala',
    desc: 'Smoked trout baccala with cauliflower, fennel and toast.',
    dietary: ['No Nuts', 'No Soy']
  }, {
    name: 'Seared Ahi Tuna',
    desc: 'Seared ahi tuna with Ethiopian root vegetable alicha.',
    dietary: ['No Dairy', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Yellowfin Tuna Kitfo',
    desc: 'Yellowfin tuna kitfo with mitmita, tomato confit, shiso, green olive oil and toast points.',
    dietary: ['No Dairy', 'No Gluten', 'No Nuts', 'No Soy']
  }, {
    name: 'Wild Mushroom Crostini',
    desc: 'Wild mushroom crostini with manchego cheese, english peas and berbere.',
    dietary: ['Vegetarian', 'No Nuts', 'No Soy']
  }, {
    name: 'Pistachio Baklava',
    desc: 'Pistachio baklava with honey and cardamom infused chocolate sauce.',
    dietary: ['Vegetarian', 'Contains Nuts']
  }]
}];
export function Menu() {
  return <main className="min-h-screen w-full bg-cream pt-24 pb-20" data-id="element-161">
      {/* HEADER */}
      <section className="py-16 md:py-24 bg-forest text-cream relative overflow-hidden mb-16" data-id="element-162">
        <div className="absolute inset-0 opacity-10 bg-pattern-mudcloth" data-id="element-163" />
        <div className="container mx-auto px-4 md:px-8 relative z-10 text-center max-w-3xl" data-id="element-164">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-165">
            <h1 className="text-5xl md:text-7xl font-serif mb-6 text-saffron" data-id="element-166">
              Catering Menu
            </h1>
            <p className="text-lg md:text-xl text-cream/80 leading-relaxed mb-8" data-id="element-167">
              Explore our vibrant selections. All items are available for
              catering orders and can be customized to fit your event's needs.
            </p>
            <Button variant="primary" onClick={() => {
            window.location.href = '/#inquiry';
          }} data-id="element-168">
              Start an Order
            </Button>
          </motion.div>
        </div>
      </section>

      {/* MENU CONTENT */}
      <section className="container mx-auto px-4 md:px-8 max-w-5xl" data-id="element-169">
        <div className="space-y-24" data-id="element-170">
          {menuCategories.map((category, idx) => <motion.div key={category.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} data-id="element-171">
              <div className="mb-10 text-center md:text-left border-b-2 border-charcoal/10 pb-6" data-id="element-172">
                <h2 className="text-3xl md:text-4xl font-serif text-terracotta mb-3" data-id="element-173">
                  {category.title}
                </h2>
                <p className="text-charcoal/60 text-lg" data-id="element-174">
                  {category.description}
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-175">
                {category.items.map(item => <div key={item.name} className="group" data-id="element-176">
                    <div className="mb-2" data-id="element-177">
                      <h3 className="text-xl font-serif text-charcoal group-hover:text-terracotta transition-colors" data-id="element-178">
                        {item.name}
                      </h3>
                    </div>
                    <p className="text-charcoal/70 text-sm leading-relaxed mb-3 pr-8" data-id="element-179">
                      {item.desc}
                    </p>
                    {item.dietary && <div className="flex gap-2" data-id="element-180">
                        {item.dietary.map(diet => <span key={diet} className="text-[10px] uppercase tracking-wider font-bold bg-charcoal/5 text-charcoal/60 px-2 py-1 rounded-sm" data-id="element-181">
                            {diet}
                          </span>)}
                      </div>}
                  </div>)}
              </div>
            </motion.div>)}
        </div>

        {/* BOTTOM CTA */}
        <div className="mt-32 p-12 bg-saffron text-center border border-charcoal/10" data-id="element-182">
          <h3 className="text-3xl font-serif text-charcoal mb-4" data-id="element-183">
            Ready to plan your menu?
          </h3>
          <p className="text-charcoal/80 mb-8 max-w-xl mx-auto" data-id="element-184">
            Our team is ready to help you select the perfect combination of
            dishes for your guests.
          </p>
          <Button variant="outline" size="lg" className="border-charcoal text-charcoal hover:bg-charcoal hover:text-saffron" onClick={() => {
          window.location.href = '/#inquiry';
        }} data-id="element-185">
            Inquire Now
          </Button>
        </div>
      </section>
    </main>;
}